export default function getDesktopDownloadUrl(electronVersion, isMac, isWindows) {
  if (isMac) {
    return `https://dl.idagio.com/IDAGIO-${electronVersion.mac}.dmg`;
  }
  if (isWindows) {
    return `https://dl.idagio.com/IDAGIO%20Setup%20${electronVersion.win}.exe`;
  }
  return null;
}
